import $ from 'jquery';
import Cookies from 'js-cookie';

export default function (config) {
(function($){
    if(typeof CRUserInfo != 'undefined' && typeof CRUserInfo.ready === 'function' ){
        CRUserInfo.ready().then( doSiteCatalystProperties )
    } else {
        $(document).on('userInfo_ready', doSiteCatalystProperties )
    }
})(jQuery);

function doSiteCatalystProperties(){

    const SEO = $.extend({
        siteCatalystGlobal: '',
        alternateProperties: {},
        siteCatalystPageProperties: {},
        siteCatalystTemplates: {}
    }, config);

    if (window.s) {
        window.s.trackExternalLinks = false;
    }

    // load
    siteCatalystOnLoadEvent();

    // navigation component
    $('.model-nav__link a[data-target][data-href], .model-section__heading a[data-target][data-toggle]').bind('click', function (event, data) {
        if(data && data.suppressSC) return;

        if (event.currentTarget.dataset.target && (!$(this).attr('aria-expanded') || $(this).attr('aria-expanded') === 'false')) {
            const path = event.currentTarget.dataset.target.replace(/[\/#]*(-body)?/g, '');
            siteCatalystPageEvent(path, 'products');
        }
    });

    // news component
    $(document).on('NEWS_LOADED', function () {
        $('.product-model-news-items .j-news').bind('click', function () {
            const title = $(this).find('.product-model-news-title').html();
            siteCatalystOnClickLinkEvent(title, (SEO.siteCatalystPageProperties.prop72 || '') + '_nav');
        });
    });

    // shopping button
    $('button.rj-shopping-button').bind('click', function () {
        const $button = $(this).closest('.rj-shopping-button');
        const brandName = $button.data('brandname');
        const productName = $button.data('modelname');
        const s = s_gi(SEO.siteCatalystGlobal);
        var override = {};
        override.linkTrackVars = 'events,prop48,eVar48,prop72,eVar72';
        override.linkTrackEvents = 'event25';
        override.prop48 = override.eVar48 = s.pageName + ' | ' + brandName + ' ' + productName;
        override.events = 'event25';

        s.tl(this, 'o', 'shop', override);
    });

    // pinned subscribe button
    $('.model-nav .overall-score__locked').bind('click', function (event) {
        event.stopPropagation();
        const s = s_gi(SEO.siteCatalystGlobal);
        var override = {};
        override.linkTrackVars = 'events,prop48,eVar48,prop58,eVar58,prop72,eVar72';
        override.prop48 = override.eVar48 = s.pageName + ' | '+'subscribe-pinned_nav';
        override.prop58 = override.eVar58 = vendor.pageInfo.getLayout();
        override.prop72 = override.eVar72 = SEO.siteCatalystPageProperties.prop72 || '';

        s.tl(this, 'o', 'subscribe-pinned-nav', override);
    });

    // compare bucket
    $(document).bind('click', {view: 'compare_view', add: 'compare_add', remove: 'compare_remove'}, function (event) {
        let isImage = true;
        $.each(event.data, function (key, value) {
            if ($(event.target).hasClass('compare-bucket__button--' + key)) {
                isImage = false;
                if (key === 'remove') {
                    event.preventDefault();
                }
                siteCatalystCompareBucketOnClickEvent(value, 'button');
            }
        });
        if (isImage && $(event.target).closest('.compare-bucket__button--model').length === 1) {
            siteCatalystCompareBucketOnClickEvent('compare_model', 'image');
        }
    });

    // footer
    $('[data-trackpagelink]').bind('click', function (event) {
        siteCatalystTrackPageLinkDataAttributeOnClickEvent.apply(window, new Function('return ' + $(this).data('trackpagelink'))() || []);
    });

    const getUrlParameter = function getUrlParameter(url, name) {
        let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
        if (results === null){
            return null;
        } else{
            return decodeURI(results[1]) || 0;
        }
    };

    $(document).on('expiredSubscription', function() {
        'use strict';
        var s = s_gi(SEO.siteCatalystGlobal);
        s.prop1 = 'ExpiredLoginModal';
        s.pageName = 'CRO:ExpiredLoginModal';
        s.t();
    });

    window.expiredWindowClick = function(action) {
        siteCatalystOnClickLinkEvent(action);
    }

    $(document).on("cro.products.model.price", function(event, data) {
        if(s && data)
            s.linkInternalFilters += "," + data; //block ebay, amazon from recording as an exit link. This is required so as to only capture clicks as custom link.
        $(".rj-price").bind('click', function (event) {
            let s = s_gi(SEO.siteCatalystGlobal);
            var override = {};
            const marketPlace = event.currentTarget.dataset.shoppingMarket;
            const merchantName = event.currentTarget.dataset.shoppingMerchant;
            const vendor = marketPlace + '-' + merchantName;
            const amazonTrackingID = getUrlParameter($(event.currentTarget).attr('href'), "tag");
            let contextName = '';
            switch (event.currentTarget.dataset.context) {
                case 'seller':
                    contextName = 'Seller';
                    override.prop48 = override.eVar48 = `${s.pageName} | ${vendor}-${contextName}`;
                    override.linkTrackEvents = override.events = 'event28';
                    override.linkTrackVars = 'events,products,eVar7,prop48,eVar48';
                    break;
                case 'buyFrom':
                    contextName = 'Buy From';
                    override.prop48 = override.eVar48 = `${s.pageName} | ${vendor}-${contextName}`;
                    override.linkTrackEvents = override.events = 'event29';
                    override.linkTrackVars = 'events,eVar7,prop48,eVar48';
                    break;
                default:
                    contextName = 'Shop';
                    override.prop48 = override.eVar48 = `${s.pageName} | ${vendor}`;
                    override.linkTrackEvents = override.events = 'event12';
                    override.linkTrackVars = 'events,products,eVar7,prop48,eVar48';
                    override.products = ";" + event.currentTarget.dataset.productid;
            }
            const linkName = `${vendor}-${contextName}-${amazonTrackingID}`;
            override.eVar7 = vendor;
            return setTimeout(function () {
                s.tl(this, 'o', linkName, override );
            }, 1);
        });
    });

    function siteCatalystOnLoadEvent() {
        let s = s_gi(SEO.siteCatalystGlobal);
        s = getSiteCatalystPageLoad(s);
        const s_code = s.t();
        if (s_code) {
            document.write(s_code);
        }

    }

    function siteCatalystOnClickLinkEvent(linkName, linkLocation) {
        const s = s_gi(SEO.siteCatalystGlobal);
        var override = {};
        override.linkTrackVars = 'prop48,eVar48,prop72,eVar72';
        if (!linkName) {
            linkName = '';
        }
        override.prop48 = override.eVar48 = s.pageName + ' | ' + linkName.toLowerCase().replace(/ /g, '_');
        if (linkLocation) {
            override.prop48 = override.eVar48 = override.prop48 + '-' + linkLocation + '_nav';
        }
        override.prop72 = override.eVar72 = SEO.siteCatalystPageProperties.prop72 || '';

        return setTimeout(function () {
            s.tl(this, 'o', linkName.replace(/ /g, '_'), override);
        }, 1);
    }

    function siteCatalystPageEvent(path, type, arg1) {
        let s = s_gi(SEO.siteCatalystGlobal);
        if (type == 'products' && path) {
            if (SEO.alternateProperties.prop4) {
                SEO.siteCatalystPageProperties.prop4 = SEO.alternateProperties.prop4[path.replace(/\//g, '')]; //for model page
            }
        } else if (type == 'ratings' && arg1) {
            if (SEO.alternateProperties.prop3) {
                SEO.siteCatalystPageProperties.prop3 = SEO.alternateProperties.prop3[arg1]; //for ratings page
            }
        } else if (type == 'compare' && arg1) {
            s.products = arg1.toString();
        }
        s = getSiteCatalystPageLoad(s);
        gtmPageEvent(path, type, arg1); // track changes into google tag manager
        return setTimeout(function () {
            s.t();

        }, 1);
    }

    function getSiteCatalystPageLoad(s) {
        s = getSiteCatalystDefaultProperties(s);
        if (s.prop1 && s.prop2 && s.prop3 && s.prop4) {
            SEO.siteCatalystPageProperties.pageName = s.pageName = 'CRO:' + s.prop1 + ':' + s.prop2 + ':' + s.prop3 + ':' + s.prop4;
        }
        return s;
    }

    function getSiteCatalystDefaultProperties(s) {
        const generalProps = getGeneralAnalyiticsProperties();
        let val;

        for (val in SEO.siteCatalystPageProperties) {
            s[val] = SEO.siteCatalystPageProperties[val];
        }

        s.prop16 = generalProps.userType || '';
        s.linkInternalFilters += ',www.cars.com';

        if (typeof CRUserInfo != 'undefined') {
            if (typeof CRUserInfo.getTier === 'function') {
                var tier = CRUserInfo.getTier();
                if (tier) {
                    s.prop27 = s.eVar80 = tier.toLowerCase();
                    s.linkTrackVars += ',prop27,eVar80';
                }
            }
            if (typeof CRUserInfo.subscriptionsOwned === 'function') {
                var subscriptionsOwned = CRUserInfo.subscriptionsOwned();
                if (subscriptionsOwned) {
                    s.prop28 = s.eVar86 = subscriptionsOwned;
                    s.linkTrackVars += ',prop28,eVar86';
                }
            }
        }

        s.eVar58 = s.prop58 = generalProps.layout || 'Desktop';

        if ('true' == Cookies.get('siteCatalystLoginSuccess')) {
            s.events = 'event13';
            Cookies.get('siteCatalystLoginSuccess', null, {
                expires: -1,
                path: '/',
                domain: '.' + document.domain.split('.').slice(-2).join('.')
            });
        }

        /* c-reidho: DRS-129 */
        if (s_getLoadTime()) {
            //s.events = s.apl(s.events, 'event45=' + s_getLoadTime(), ',', 1);
        }
        return s;
    }

    function getGeneralAnalyiticsProperties() {
        const userInfo = convertQStoJSON(Cookies.get('userInfo'));
        const props = [];
        if (userInfo !== '') {
            const userId = userInfo.ID || '';
            const productList = userInfo.products || '';
            if (productList.indexOf('CRO') !== -1) {
                props.userId = userId;
                props.userType = 'subscriber';
            } else {
                props.userType = 'visitor';
            }
        } else {
            props.userType = 'visitor';
        }

        props.layout = vendor.pageInfo.getLayout();

        return props;
    }

    function convertQStoJSON(qstr) {
        if (!qstr) {
            return '';
        }
        const fields = qstr.split('&');
        const result = {};
        fields.forEach(function (pair) {
            pair = pair.split('=');
            const key = pair[0];
            const value = decodeURIComponent(pair[1] || '');
            if (result[key]) {
                if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                    result[key].push(value);
                } else {
                    result[key] = [result[key], value];
                }
            } else {
                result[key] = value;
            }
        });
        return JSON.parse(JSON.stringify(result));
    }

    /* c-reidho: DRS-129 */
    function s_getLoadTime() {
        let s_loadT2 = window.s_loadT2;
        if (!s_loadT2) {
            let b = new Date().getTime(), o = window.performance ? window.performance.timing : 0,
                a = o ? o.requestStart : window.inHeadTS || 0; // ToDo where is inHeadTS defined? (Adobe Analytics)
            s_loadT2 = a ? Math.round((b - a) / 100) : '';
        }
        return s_loadT2;
    }

    function gtmPageEvent(path, type, arg1) {
        const currDataLayer = (window.dataLayer) ? window.dataLayer[0] : {};
        if (type == 'products' && path) {
            if (currDataLayer.siteSectionL3) {
                currDataLayer.siteSectionL3 = SEO.alternateProperties.prop4[path.replace(/\//g, '')]; //for model page
            }
        } else if (type == 'ratings' && arg1) {
            if (currDataLayer.siteSectionL2) {
                currDataLayer.siteSectionL3 = SEO.alternateProperties.prop3[arg1]; //for ratings page
            }
        } else if (type == 'compare' && arg1) {
            // Empty
        }
        window.dataLayer.push([currDataLayer]);
    }

    function siteCatalystCompareBucketOnClickEvent(linkName, linkReferrer) {
        const s = s_gi(SEO.siteCatalystGlobal);
        var override = {};
        linkName = linkName || '';
        override.linkTrackVars = 'prop48,eVar48,prop58,eVar58,prop72,eVar72';
        override.prop48 = override.eVar48 = s.pageName + ' | ' + linkName + '-' + linkReferrer;
        override.prop58 = override.eVar58 = vendor.pageInfo.getLayout();
        override.prop72 = override.eVar72 = SEO.siteCatalystPageProperties.prop72 || '';
        return setTimeout(function () {
            s.tl(this, 'o', linkName, override);
        }, 1);
    }

    function siteCatalystTrackPageLinkDataAttributeOnClickEvent(linkName, linkLocation, linkReferrer, linkPrefix) {
        const s = s_gi(SEO.siteCatalystGlobal);
        var override = {};
        linkName = linkName || '';
        let prop48 = linkName;

        if (linkPrefix != null) {
            if (linkPrefix == 'social') {
                override = siteCatalystTrackPageLinkDataAttributeTrackEvent(override, 'event3');
                override.eVar5 = linkName;
            } else {
                prop48 = linkPrefix + '-' + prop48;
            }
        }

        if (linkLocation != null) {
            prop48 = prop48 + '-' + linkLocation;
        }

        if (linkReferrer != null) {
            prop48 = prop48 + '^' + linkReferrer;
        }

        prop48 = s.pageName + ' | ' + prop48;
        override.prop48 = override.eVar48 = prop48;
        override.linkTrackVars = 'prop48,eVar48';

        if (s.prop72) {
            s.linkTrackVars += ',prop72,eVar72';
        }

        if (override.eVar5) {
            override.linkTrackVars += ',eVar5';
        }

        if (linkName === 'donate') {
            override = siteCatalystTrackPageLinkDataAttributeTrackEvent(override, 'event24');
        }

        if (linkLocation === 'header' || linkLocation === 'subheader') {
            override = siteCatalystTrackPageLinkDataAttributeTrackEvent(override, 'event32');
        }

        if (linkLocation === 'footer') {
            override = siteCatalystTrackPageLinkDataAttributeTrackEvent(override, 'event33');
        }

        if (vendor.pageInfo.getLayout() === 'Mobile') {
            override['prop58'] = override['eVar58'] = "Mobile";
            override.linkTrackVars += ',prop58,eVar58';
        }

        s.tl(this, 'o', linkName, override);
        return true;
    }

    function siteCatalystTrackPageLinkDataAttributeTrackEvent(s, event) {
        if (s.linkTrackVars.indexOf('events') == -1) {
            s.linkTrackVars += s.linkTrackVars.length > 0 ? ',events' : 'events';
        }
        if (s.linkTrackEvents.indexOf(event) == -1) {
            s.linkTrackEvents += s.linkTrackEvents.length > 0 ? ',' + event : event;
        }
        if (s.events.indexOf(event) == -1) {
            s.events = s.apl(s.events, event, ',');
        }
        return s;
    }
}
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/SiteCatalyst/model.js